<template lang="html">
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :show-close="true"
    :before-close="onClose"
    append-to-body
    width="480px"
    >

    <template v-if="loading">
      <loading />
    </template>

    <div v-if="errors && errors.length" style="margin-bottom: 16px;">
      <el-alert
        title="Возникли ошибки"
        :description="getErrors()"
        type="error"
        show-icon
        @close="hideError">
      </el-alert>
    </div>

    <div class="" v-if="formDataCurrent">
      <div class="mb-4">
        <el-alert
          :title="getParameterLabelByType(formDataCurrent.type)"
          type="info"
          show-icon
          :closable="false">
        </el-alert>
      </div>

      <el-form label-position="top" label-width="160px" size="mini" :model="formDataCurrent">

        <div style="border: 1px dotted grey; margin-bottom: 18px; padding: 12px;">
          <el-form-item label="Заголовок *">
            <el-input v-model="formDataCurrent.name"></el-input>
          </el-form-item>

          <el-form-item label="Описание *">
            <el-input v-model="formDataCurrent.description" type="textarea" :rows="2"></el-input>
          </el-form-item>

          <el-form-item v-if="(formDataCurrent.type == 6 || formDataCurrent.type == 7)" label="Список переключений">
            <!--<v-radio-group xs12>-->
              <v-radio-group row v-model="initialFormData.custom.default">
                <draggable v-model="initialFormData.custom.list" style="width: 100%;" handle=".handle">
                  <v-layout row mb-2 v-for="(item, index) in initialFormData.custom.list" :key="index">
                    <v-icon class="handle" style="cursor: move; display: flex; align-self: center;">mdi-menu</v-icon>
                    <v-flex xs9>
                      <el-input xs10 v-model="item.value"></el-input>
                    </v-flex>
                    <v-flex xs1 pl-3>

                        <v-radio
                          :key="index"
                          :value="index"
                        ></v-radio>

                    </v-flex>
                    <v-flex xs2 pl-4>
                      <el-button @click="removeLocalListItem(index)" class="el-icon-delete" size="small"></el-button>
                    </v-flex>
                  </v-layout>
                </draggable>
                <v-flex xs12>
                  <el-button @click="addLocalListItem()" size="small">+ Добавить элемент</el-button>
                </v-flex>
              <!--</v-radio-group>-->
              </v-radio-group>
          </el-form-item>

          <el-form-item v-if="formDataCurrent.type == 8 || formDataCurrent.type == 10" label="Источник данных (ссылка)">
            <v-flex xs12>
              <el-input xs12 v-model="formDataCurrent.options.url"></el-input>
            </v-flex>
          </el-form-item>

          <el-form-item v-if="formDataCurrent.type == 9" label="Типы файлов">
            <v-flex xs12>
              <template>
  <el-select
    xs12
    v-model="formDataCurrent.options.ext"
    multiple
    filterable
    allow-create
    default-first-option
    placeholder="Выберите допустимые типы файлов"
  >
    <el-option v-for="item in extensions" :key="item.value" :label="item.label" :value="item.value"></el-option>
  </el-select>
</template>
            </v-flex>
          </el-form-item>



          <div><small>* &ndash; эти поля будут видны пользователю</small></div>
        </div>

        <el-form-item label="Префикс">
          <el-input v-model="formDataCurrent.symbol"></el-input>
        </el-form-item>

        <!-- <el-checkbox v-model="formDataCurrent.required">Обязательное</el-checkbox><br/> -->
        <!-- <el-checkbox v-model="formDataCurrent.single">Монопольно</el-checkbox><br/> -->
        <el-checkbox v-model="formDataCurrent.multi">Мультизначный параметр</el-checkbox><br/>

      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose()" size="small">{{ cancelText }}</el-button>
      <el-button v-show="!loading" :loading="loadingSubmit" type="primary" @click="onSubmit()" size="small">{{ submitText }}</el-button>
    </span>

  </el-dialog>
</template>

<script>
// mixins
import dialogForm from "../../../mixins/dialogForm";
import designer from "../../mixins/designer";
import uuidv4 from "uuid/v4";
import draggable from "vuedraggable";
import { cloneDeep } from "lodash";

export default {
  mixins: [dialogForm, designer],
  components: {
    draggable
  },
  data() {
    return {
      radiobuttonItems: [],
      initialFormData: {
        custom: {
          list: [
            {
              key: uuidv4(),
              value: ""
            }
          ],
          default: 0
        },

        source: {
          url: ""
        },

        file: {
          ext: []
        }
      },

      chips: ["jpg", "gif", "bpm", "png"],
      items: [],
      search: "",

      extensions: [
        {
          value: "jpg",
          label: "jpg"
        },
        {
          value: "gif",
          label: "gif"
        },
        {
          value: "bpm",
          label: "bpm"
        },
        {
          value: "png",
          label: "png"
        },
        {
          value: "doc",
          label: "doc"
        },
        {
          value: "xls",
          label: "xls"
        },
        {
          value: "pdf",
          label: "pdf"
        }
      ],
      value: []
    };
  },
  methods: {
    /**
     * метод срабатывает перед закрытием окна диалога
     *
     */
    onClose() {
      this.initialFormData.custom = {
        list: [
          {
            key: uuidv4(),
            value: ""
          }
        ],
        default: 0
      };
      this.doCancel();
    },

    /**
     * добавление элемента списка
     *
     */
    addLocalListItem() {
      this.initialFormData.custom.list.push({
        key: uuidv4(),
        value: ""
      });
    },

    /**
     * удаление элемента списка
     *
     */
    removeLocalListItem(index) {
      this.initialFormData.custom.list.splice(index, 1);
    },

    /**
     * Сохранение
     * обнуляет локальные поля, и вызывает стандартный метод
     */
    onSubmit() {

      if ( this.formDataCurrent.options ) {

        this.formDataCurrent.options.default = this.initialFormData.custom.default;

        this.formDataCurrent.options.list = cloneDeep(
          this.initialFormData.custom.list
        );
      }

      this.initialFormData.custom = {
        list: [
          {
            key: uuidv4(),
            value: ""
          }
        ],
        default: 0
      };

      this.doSubmit();
    },

    /**
     *
     *
     */
    validate: function() {
      this.clearErrors();

      if (this.formDataCurrent.symbol == "") {
        this.errors.push("Поле 'Префикс' не должно быть пустым.");
      }

      if (this.formDataCurrent.name == "") {
        this.errors.push("Поле 'Заголовок' не должно быть пустым.");
      }
    },

    /**
     *
     *
     */
    updateCurrentData: function() {
      this.formDataCurrent = Object.assign({}, this.formData);

      if (typeof this.formDataCurrent.options === "undefined") {
        let options = this.getInitialData(this.formDataCurrent.type);

        if (options) {
          this.formDataCurrent.options = options;
          this.formData.options = options;
        }
      } else if (
        this.formDataCurrent.options &&
        (this.formDataCurrent.type == 6 || this.formDataCurrent.type == 7)
      ) {
        this.initialFormData.custom.default = this.formDataCurrent.options.default;
        this.initialFormData.custom.list = cloneDeep(
          this.formDataCurrent.options.list
        );
      }
    },

    /**
     *
     *
     * @returns {*}
     */
    collectResults: function() {
      return this.formDataCurrent;
    },

    /**
     *
     *
     * @param type
     * @returns {*}
     */
    getInitialData: function(type) {


      if (type == "6" || type == "7") {
        return this.initialFormData.custom;
      } else if (type == "8" || type == "10") {
        return this.initialFormData.source;
      } else if (type == "9") {
        return this.initialFormData.file;
      }

      return null;
    },

    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [...this.chips];
    },

    updateTags() {
      this.$nextTick(() => {
        this.chips.push(...this.search.split(","));
        this.$nextTick(() => {
          this.search = "";
        });
      });
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/apps/bpm/designer/components/forms/ParameterDialog.vue